import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';

import { WindowSizeService } from '@vbrick/vb-lxp-lib';
import { map, tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class LiveStreamMenuService {
	private readonly windowSizeService = inject(WindowSizeService);
	private readonly standingsOpenSubject = new BehaviorSubject<boolean>(false);
	private readonly chatOpenSubject = new BehaviorSubject<boolean>(false);

	isStandingsOpen$: Observable<boolean> = this.standingsOpenSubject.asObservable();
	isChatOpen$: Observable<boolean> = this.chatOpenSubject.asObservable();
	public onlyOneTower: boolean = false;

	private readonly standingTowerExpandedSubject = new BehaviorSubject<boolean>(false);
	public standingTowerExpanded$: Observable<boolean> = this.standingTowerExpandedSubject.asObservable();

	public get isStandingTowerExpanded(): boolean {
		return this.standingTowerExpandedSubject.value;
	}

	private readonly subscription = combineLatest([this.standingTowerExpanded$, this.windowSizeService.isMobile$])
		.pipe(
			// If the standings tower is expanded, it should be open, otherwise it should be closed
			// if the window size is mobile, then only one tower should be open
			map(([expanded, isMobile]) => expanded || isMobile),
			tap(oneTower => {
				this.onlyOneTower = oneTower;
				if (oneTower) {
					// If only one tower should be opened, close the other tower
					 if (this.chatOpenSubject.value) {
						this.chatOpenSubject.next(false);
					 }
				}
			})
		).subscribe();

	public toggleStandings(): void {
		const currentValue = this.standingsOpenSubject.value;
		if (this.onlyOneTower) {
			// If only one tower should be opened, close the chat tower
			this.chatOpenSubject.next(false);
		}
		this.standingsOpenSubject.next(!currentValue);
	}

	public openStandings(): void {
		this.chatOpenSubject.next(false);
		this.standingsOpenSubject.next(true);
	}

	public toggleChat(): void {
		const currentValue = this.chatOpenSubject.value;
		if (this.onlyOneTower) {
			// If only one tower should be opened, close the standings towe
			this.standingsOpenSubject.next(false);
		}
		this.chatOpenSubject.next(!currentValue);
	}

	public closeAll(): void {
		this.standingsOpenSubject.next(false);
		this.chatOpenSubject.next(false);
	}

	public setStandingTowerExpanded(expanded: boolean): void {
		this.standingTowerExpandedSubject.next(expanded);
	}

	public cleanup(): void {
		this.subscription?.unsubscribe();
	}
}